import Vue from "vue";
import Vuex from "vuex";





Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
	modal: {
		show: false,
		component: null,
		title: null,
		footer: false,
		hideLogo: false,
		closeBackdrop: true
	},
	baseDomain: process.env.VUE_APP_SITE_DOMAIN,
	baseAPI: process.env.VUE_APP_API_DOMAIN,
	navigation: []
  },
  mutations: {
  	showModal(state, { title, component, footer, category, hideLogo, closeBackdrop, vendor }){
		state.modal.show = true
		state.modal.title = title
		state.modal.component = component
		state.modal.footer = footer
		state.modal.leadCategory = category
		state.modal.hideLogo = hideLogo
		state.modal.closeBackdrop = closeBackdrop
		state.modal.vendor = vendor	
  	},
  	hideModal(state){
		state.modal.show = false
		state.modal.title = null
		state.modal.component = null
		state.modal.footer = false
  	},
  	// async getNavigation(state){
  	// 	const { data } = await ContentRepository.getMenu()
  	// 	state.navigation = data
  	// 	console.log('data', data)

  	// 	// console.log('in get navigation', data)

  	// 	// expire navigation in one day
  	// 	var navExpire = store._vm.$moment().add(1, 'days')

  	// 	if (!store._vm.$session.exists()){
  	// 		store._vm.$session.start()
  	// 	}
  	// 	store._vm.$session.set('navigation', state.navigation)
   //    	store._vm.$session.set('navigation_exp', navExpire)

            	
  	// },
  	setNavigation(state, {data}){
  		state.navigation = data

		// if no session
		if (!store._vm.$session.exists()){
			store._vm.$session.start()  
		}
		store._vm.$session.set('navigation', data)
  		// console.log('state.navigation', state.navigation)
  	}
  },
  actions: {
		showModal(context, {title, component, footer, category, hideLogo, closeBackdrop, vendor}) {
			context.commit ('showModal', {
				title,
				component,
				footer,
				category,
				hideLogo,
				closeBackdrop,
				vendor
			})
		},
		hideModal(context){
			context.commit ('hideModal')
		},
		// getNavigation(context){
		// 	context.commit('getNavigation')
		// },
		setNavigation(context, {data}){
			context.commit('setNavigation', {
				data
			})
		}
  },
  getters: {
  	getSiteNav: state => state.navigation
  },
  modules: {}
});


export default store;